module.exports = __webpack_public_path__ + "img/tradein5.c3634772.jpg";